import { useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'
import Header from './Sections/Header'
import HeroSection from './Sections/HeroSection'
import Features from './Sections/Features'
import MustExistSection from './Sections/MustExist'
// import DifferentPlatform from '@components/pages/advantageous/DifferentPlatform'
import Edugram500 from '@components/pages/advantageous/Edugram500'
import PublishCourse from '@components/pages/advantageous/PublishCourse'
import Footer from '@components/organisms/FooterNew'
import SafeContent from './Sections/SafeContent'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
const AuthorDetailsModal = dynamic(
  () => import('@components/pages/become-author/AuthorDetailsModal'),
  { ssr: false }
)
import { useAuth } from '@contexts/Auth'
import { useRouter } from 'next/router'
import { Spacer } from '@nextui-org/react-latest'
import withLenis from '@components/HOCs/LenisWrapper'

// Dynamic imports for specific components
const Testimonials = dynamic(
  () => import('@components/pages/advantageous/Testimonials')
)
const TrustedStudents = dynamic(() => import('./Sections/TrustedStudents'))
const Explore = dynamic(() => import('@components/pages/advantageous/Explore'))
const FAQSection = dynamic(
  () => import('@components/pages/advantageous/FAQSection')
)

type Props = {}

const LandingPage = ({}: Props) => {
  const [showBecomeAuthorModal, setShowBecomeAuthorModal] = useState(false)
  const { t, i18n } = useTranslation(['home'])
  const { user, isAuthenticated, setShowAuthModal } = useAuth()
  const freshLoggedIn = useRef(false)
  const router = useRouter()

  useEffect(() => {
    if (user && !user?.isAuthor && freshLoggedIn.current) {
      setShowBecomeAuthorModal(true)
    }

    return () => {
      freshLoggedIn.current = false
    }
  }, [user])

  const handleBecomeCreator = () => {
    if (!isAuthenticated) {
      setShowAuthModal(true)
      freshLoggedIn.current = true
      return
    }
    if (user?.isAuthor) router.push('/author')
    else setShowBecomeAuthorModal(true)
  }

  return (
    <div>
      <Head>
        <title>Edugram.io</title>
        <meta name="og:title" content="Edugram.io" />
        <meta name="description" content={t('description', { ns: 'home' })} />
        <meta
          name="og:description"
          content={t('description', { ns: 'home' })}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={'Edugram.io'} />
        <meta
          name="twitter:description"
          content={t('description', { ns: 'home' })}
        />
        <meta property="og:image" content="/images/edugram.png" />
        <meta property="og:image:secure_url" content="/images/edugram.png" />
        <meta property="og:type" content="video_lecture" />
        <meta property="og:site_name" content="Edugram.io" />
        <meta property="og:locale" content={i18n.language} />
        <meta name="twitter:domain" content="www.edugram.io" />
        <meta
          name="keywords"
          content={
            'Edugram.io, education, courses, learning, resources, skills, online learning, personalized learning, career coaching, personal development, skill development, professional development'
          }
        />
      </Head>
      <Header handleBecomeCreator={handleBecomeCreator} />
      <HeroSection />
      <Features />
      {/* <DifferentPlatform /> */}
      <Spacer y={16} />
      <MustExistSection />
      <Edugram500 />
      <PublishCourse
        handleBecomeCreator={handleBecomeCreator}
        isHomeLanding={true}
      />
      <SafeContent />
      <TrustedStudents handleBecomeCreator={handleBecomeCreator} />
      <Testimonials />
      <FAQSection />
      <Explore />
      <div className="max-w-desktop mx-auto sm:px-4">
        <Footer />
      </div>
      {showBecomeAuthorModal && (
        <AuthorDetailsModal
          isOpen={showBecomeAuthorModal}
          onClose={(ask?: boolean) => {
            if (ask) {
              if (confirm('Are you sure you want to close?')) {
                setShowBecomeAuthorModal((prev) => !prev)
              }
            } else {
              setShowBecomeAuthorModal((prev) => !prev)
            }
          }}
        />
      )}
    </div>
  )
}

export default withLenis(LandingPage)
